class DestroyToggle {

    static showBox(e) {
        e.preventDefault();
        let $currentObj = $(e.currentTarget);
        $currentObj
            .hide(0)
            .next('.toggle-btn-b')
            .show(0);
    }

    static showButton(e) {
        e.preventDefault();
        let $currentObj = $(e.currentTarget);
        $currentObj
            .closest('.toggle-btn-b')
            .hide(0)
            .prev('.toggle-btn-a')
            .show(0);
    }
}


$(document).on('click', '.toggle-btn-a', (e) => {
    DestroyToggle.showBox(e);
});

$(document).on('click', '.toggle-btn-b .btn-small, .toggle-btn-b .btn', (e) => {
    DestroyToggle.showButton(e);
});

